@if (showCloseButton) {
  <button sb-icon-button [color]="'transparent'" [size]="'sm'" (click)="close()" class="sb-popover-close">
    <sb-icon [name]="'times'" />
    <span class="sr-only">{{ 'Close' | translate }}</span>
  </button>
}
@if (title) {
  <span class="mb-2 block font-bold">{{ title }}</span>
}
<div class="space-y-4">
  <ng-content></ng-content>
</div>
<span class="sb-popover-arrow">
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none">
    <path fill="currentColor" d="M11.068 10.02a2 2 0 0 1-3.136 0L0 0h19l-7.932 10.02Z" />
  </svg>
</span>
